import TaskTable from './TaskTable';
import { Box, Typography } from '@mui/material';

const TaskManagerData = (props) => {
    const {
        taskList,
        reload
    } = props;

    return (
        <Box>
            <Typography>Список задач</Typography>
            <Box display="flex">
                <TaskTable taskList={taskList} reload={reload} />
            </Box>
        </Box>
    );
}

export default TaskManagerData